<div [formGroup]="formGroup" class="file-input-container" [ngClass]="autoHeight ? 'h-auto' : 'mh-100'"
  [class.dragging]="dragging" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
  <div class="dropzone" *ngIf="dragging" (dragover)="onDragOver($event)" (drop)="onDrop($event)"
    (dragleave)="onDragLeave($event)"></div>
  <div class="row" *ngIf="dataOrUrl$ | async as dataOrUrl" [ngClass]="{'pb-4 pt-2': showFileName}">
    <div class="col-12 text-center">
      <img class="image-size" *ngIf="dataOrUrl && !isPdf" [src]="dataOrUrl" />
      <p class="my-1" *ngIf="showFileName && nameControl?.value">{{ nameControl.value }}</p>
      <div *ngIf="fileSize && showFileSize">{{ fileSize }}</div>
      <small *ngIf="enabled && showMaxSizeInfo">
        {{'ImageInput.MaximumInfo' | translate: { width: maxWidth, height: maxHeight} }}
      </small>
    </div>
  </div>
  <div class="row py-2">
    <div class="col-12 d-flex justify-content-center align-items-center">
      <button mat-button
        class="upload-btn-size"
        [ngClass]="{'mw-80': showTooltip}"
        type="button"
        [disabled]="!enabled"
        (click)="uploadFile()"
        matTooltip="{{ 'ImageInput.UploadImageTooltip' | translate }}"
        [matTooltipDisabled]="!showTooltip"
      >
        {{ uploadLabel | translate }}
      </button>
      <div class="info-icon">
        <mat-icon color="primary"
          *ngIf="showTooltip"
          class="cursor-pointer"
          matTooltip="{{ 'Common.ImageAspectRatio' | translate: { width: ratioWidth, height: ratioHeight } }}"
        >
          info
        </mat-icon>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <mat-error *ngIf="dataControl?.touched && dataControl?.errors">
        {{ 'ImageInput.RequiredError' | translate }}
      </mat-error>
    </div>
  </div>
  <input type="file" [accept]="accept" #fileInput value="Browse" class="browse-btn" (change)="onChange($event)">
</div>

<div *ngIf="canRemove" class="row px-3">
    <button type="button" *ngIf="dataOrUrl$ | async as dataOrUrl" class="mt-2 w-100" mat-raised-button (click)="removeFile()">
      {{ 'Common.DeleteImage' | translate }}
    </button>
</div>